import { graphql } from '@/gql';
import type { SearchGroceryItemsQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { PaginatedGrocerySearchItemTypeResponse } from '@/models/grocery';

// Fragments
import './fragments/grocerySearchItemFragment';

export const searchGroceryItems = async ({
  storeId,
  zipCode,
  latitude,
  longitude,
  country,
  query,
  page,
  limit,
}: SearchGroceryItemsQueryVariables) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      storeId,
      zipCode,
      latitude,
      longitude,
      country,
      query,
      limit,
      page,
    },
    query: graphql(`
      query SearchGroceryItems(
        $storeId: String!
        $zipCode: String!
        $latitude: Float!
        $longitude: Float!
        $country: String!
        $query: String!
        $page: Float
        $limit: Float
      ) {
        searchGroceryItems(
          storeId: $storeId
          zipCode: $zipCode
          latitude: $latitude
          longitude: $longitude
          country: $country
          query: $query
          page: $page
          limit: $limit
        ) {
          ...GrocerySearchItemFragment
        }
      }
    `),
  });

  return response.data.searchGroceryItems as PaginatedGrocerySearchItemTypeResponse;
};
